import { render, staticRenderFns } from "./TransposonDetail.vue?vue&type=template&id=41ea5482&scoped=true"
import script from "./TransposonDetail.vue?vue&type=script&lang=js"
export * from "./TransposonDetail.vue?vue&type=script&lang=js"
import style0 from "./TransposonDetail.vue?vue&type=style&index=0&id=41ea5482&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ea5482",
  null
  
)

export default component.exports